import { render, staticRenderFns } from "./projectDetailView.vue?vue&type=template&id=10027158&scoped=true"
import script from "./projectDetailView.vue?vue&type=script&lang=js"
export * from "./projectDetailView.vue?vue&type=script&lang=js"
import style0 from "./projectDetailView.vue?vue&type=style&index=0&id=10027158&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10027158",
  null
  
)

export default component.exports